"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const unavailability_modal_1 = require("@app/component/modals/unavailability-1.5/unavailability-modal");
const request_1 = require("@app/request");
const query_1 = require("@app/request/query");
const util_1 = require("@app/util");
const apollo_client_fetch_1 = require("@app/util/apollo-client-fetch");
const format_hours_1 = require("@app/util/format-hours");
const use_modal_1 = require("@app/util/modal/use-modal");
const shift_attributes_1 = require("@app/util/shift-attributes");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const TooltipContent = ({ data, type, positions, workspace, calendarMultiSelect, setCalendarMultiSelect, setModal, openPlanning, deleteLiveShift, updateLiveShift, updateShiftTemplate, auth, isPluginEnabled, isLockedDay, isCycleCalendar, cycleDetail, deleteCycleDetail, contextMenu, setContextMenu, openEventModal, eventProps, }) => {
    const topSectionRows = [];
    const hasTransferData = data.hasOffer?.transfer || data.transfer;
    const hasMaster = Boolean(hasTransferData?.master);
    const { openModal } = (0, use_modal_1.useModal)();
    const isMultiSelectEnabled = document.querySelector('.ds-ms-selector') ||
        !window.matchMedia('only screen and (max-device-width: 699px)').matches;
    const isEventMultiSelected = isMultiSelectEnabled &&
        calendarMultiSelect.isActive &&
        calendarMultiSelect.sourceEvents &&
        calendarMultiSelect.sourceEvents.some((ev) => ev.id === data.id);
    // determine what type of tooltip we're displaying
    let displayType = type;
    if (isEventMultiSelected &&
        calendarMultiSelect.sourceEvents.length > 1 &&
        !calendarMultiSelect.isSelectingTargets) {
        displayType = 'multipleEvents';
    }
    // SHIFT or SHIFT TEMPLATE
    if (displayType === 'shift' || displayType === 'shiftTemplate') {
        // Transfer
        if (data.transfer?.master || data.transfer?.slaves?.length === 1) {
            topSectionRows.push(react_1.default.createElement("div", { key: 'transfet' },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('MA_TRANSFER')),
                react_1.default.createElement("span", { className: 'v' }, data.transfer?.master
                    ? data.transfer?.master.workspaceName
                    : data.transfer?.slaves[0].workspaceName)));
        }
        // Position
        const pos = positions.find((p) => p.id === data.positionId);
        if (pos) {
            topSectionRows.push(react_1.default.createElement("div", { key: 'position' },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('POSITION')),
                react_1.default.createElement("span", { className: 'v' },
                    react_1.default.createElement(_ui_1.Position, { pos: pos }))));
        }
        // Locality
        if (data.localityId && workspace?.localities) {
            const loc = workspace.localities.find((l) => l.id === data.localityId);
            if (loc) {
                topSectionRows.push(react_1.default.createElement("div", { key: 'locality' },
                    react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('LOCALITY')),
                    react_1.default.createElement("span", { className: 'v' },
                        react_1.default.createElement(_ui_1.Locality, { ...loc }))));
            }
        }
        // Contract
        if (data.contractType) {
            const conType = workspace.contractTypes.find((ct) => ct.id === data.contractType);
            topSectionRows.push(react_1.default.createElement("div", { key: 'contract' },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('AGREEMENT')),
                react_1.default.createElement("span", { className: 'v' }, conType ? conType.name : data.contractType)));
        }
        // Work Time
        const time = data?.stats?.length
            ? util_1.timeUtil.formatMinutes(data?.stats?.reduce((a, s) => a + (s.workMinutes || 0), 0), false)
            : util_1.timeUtil.formatMinutes((0, moment_1.default)(data?.period?.end).diff(data?.period?.start, 'minutes') -
                (data?.pausesFixed
                    ? data?.pauses?.reduce((a, s) => a + (s.duration || 0), 0)
                    : util_1.timeUtil.getDefaultShiftBreaks({ details: data, workspace })
                        ?.duration || 0), false);
        topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-duration', key: topSectionRows.length },
            react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('ATTEN_DURATION')),
            react_1.default.createElement("span", { className: 'v' }, time)));
        // Overtime
        if (data?.stats?.length) {
            const totalMinutes = data.stats.reduce((a, s) => a + (s.overTimeTotalMinutes || 0), 0);
            if (totalMinutes > 0) {
                const v = data.stats.reduce((a, s) => {
                    return a + (s?.overTimeTotalMinutes || 0);
                }, 0);
                if (v !== 0) {
                    topSectionRows.push(react_1.default.createElement("div", { key: 'overtime' },
                        react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('ATTEN_OVERTIME')),
                        react_1.default.createElement("span", { className: 'v' },
                            "+",
                            (0, format_hours_1.formatHours)(v / 60))));
                }
            }
        }
        // Pauses
        if (data.pauses) {
            data.pauses.forEach((p, index) => {
                const pauseTxt = (0, util_1.t)('PAUSE_SHORT_X', {
                    dur: `${p.duration}m`,
                    start: (0, moment_1.default)(data.period.start).add(p.start, 'minutes').format('H:mm'),
                });
                topSectionRows.push(react_1.default.createElement("div", { key: `pause-${index}` },
                    react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('EVT_TOOLTIP_PAUSE')),
                    react_1.default.createElement("span", { className: 'v' }, pauseTxt)));
            });
        }
        // Duration
        topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-duration', key: topSectionRows.length },
            react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('ATTENDANCE_HOURS_LABEL.atWork')),
            react_1.default.createElement("span", { className: 'v' }, util_1.timeUtil.formatMinutes((0, moment_1.default)(data?.period?.end).diff(data?.period?.start, 'minutes'), false))));
        // Published
        if (!isCycleCalendar && type === 'shift' && !data.published) {
            topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-status', key: 'published' },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('EVT_TOOLTIP_STATUS')),
                react_1.default.createElement("span", { className: 'v' }, (0, util_1.t)(
                // data.published ? 'EVT_TOOLTIP_PUBLISHED' : 'EVT_TOOLTIP_NOT_PUBLISHED'
                'EVT_TOOLTIP_NOT_PUBLISHED'))));
        }
        // Warnings
        if (data.warnings?.length) {
            topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-warnings', key: 'warnings' },
                react_1.default.createElement(_ui_1.Alert, { text: (0, util_1.t)('WARNINGS') + ': ' + data.warnings.length, type: _ui_1.Alert.TYPES.ERROR, size: _ui_1.Alert.SIZES.SMALL })));
        }
        // Note
        // if (data.note) {
        //   topSectionRows.push(
        //     <div className='evt-tt-r-note' key='note'>
        //       <span className='k'>{t('NOTE')}</span>
        //       <span className='v'>
        //         <div>{data.note}</div>
        //       </span>
        //     </div>
        //   )
        // }
        // Shift Attributes
        const attribs = util_1.calendarUtil.getShiftAttributes(data, workspace);
        if (attribs?.length) {
            topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-attribs', key: 'attributes' },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('SHIFT_ATTRIBUTES_NAV_NAME')),
                react_1.default.createElement("span", { className: 'v' }, attribs
                    .map((att) => (0, shift_attributes_1.formatAttributeName)({ attribute: att }))
                    .join(', '))));
        }
    }
    // AVAIL OR TIMEOFF
    if (displayType === 'availability' || displayType === 'timeOff') {
        // work time
        if (type === 'timeOff' &&
            typeof data.workMinutes !== typeof null &&
            typeof data.workMinutes !== typeof undefined) {
            topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-duration', key: topSectionRows.length },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('ATTEN_DURATION')),
                react_1.default.createElement("span", { className: 'v' }, util_1.timeUtil.formatMinutes(data.workMinutes, false))));
        }
        // category
        const cat = util_1.calendarUtil.getTimeOffOrAvailCategory(data, workspace);
        topSectionRows.push(react_1.default.createElement("div", { key: topSectionRows.length },
            react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('EVT_TOOLTIP_CAT')),
            react_1.default.createElement("span", { className: 'v' }, cat.name)));
        // note
        if (data.note) {
            topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-note', key: topSectionRows.length },
                react_1.default.createElement("span", { className: 'k' }, (0, util_1.t)('NOTE')),
                react_1.default.createElement("span", { className: 'v' },
                    react_1.default.createElement("div", null, data.note))));
        }
    }
    // MULTIPLE EVENTS
    if (displayType === 'multipleEvents') {
        let countShifts = 0;
        let countAvails = 0;
        let countTimeOffs = 0;
        if (Array.isArray(calendarMultiSelect?.sourceEvents)) {
            calendarMultiSelect.sourceEvents.forEach((evt) => {
                const whatIsIt = typeof evt.available === 'undefined' && !evt.categoryId
                    ? 'shift'
                    : util_1.calendarUtil.isEventAvailabilityOrTimeOff(evt);
                if (whatIsIt === 'availability' || whatIsIt === 'unavailability') {
                    countAvails += 1;
                }
                else if (whatIsIt === 'timeOff') {
                    countTimeOffs += 1;
                }
                else {
                    countShifts += 1;
                }
            });
        }
        const selSummary = [];
        if (countShifts > 0)
            selSummary.push(countShifts.toString() + ' ' + (0, util_1.t)('MULTI_SEL_SHIFTS_MULTI'));
        if (countTimeOffs > 0)
            selSummary.push(countTimeOffs.toString() + ' ' + (0, util_1.t)('MULTI_SEL_TIMEOFF_MULTI'));
        if (countAvails > 0)
            selSummary.push(countAvails.toString() + ' ' + (0, util_1.t)('MULTI_SEL_UNAV_MULTI'));
        topSectionRows.push(react_1.default.createElement("div", { className: 'evt-tt-r-ms', key: topSectionRows.length },
            react_1.default.createElement(_ui_1.Text, { weight: _ui_1.Text.WEIGHTS.BOLD, color: _ui_1.Text.COLORS.PRIMARY, type: _ui_1.Text.TYPES.BODY_LARGE }, (0, util_1.t)('MULTI_SELECTED') + ':'),
            selSummary.map((s, i) => {
                return (react_1.default.createElement(_ui_1.Text, { key: i, weight: _ui_1.Text.WEIGHTS.BOLD, color: _ui_1.Text.COLORS.PRIMARY, type: _ui_1.Text.TYPES.BODY_LARGE }, s));
            })));
    }
    // =============================
    // CONTEXT MENU BUTTON HANDLERS:
    // =============================
    // add shift handler
    const handleAddShift = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isCycleCalendar) {
            const dataFromId = data.id.split('_');
            const sortDetails = cycleDetail.data.sort(function (a, b) {
                return a.id > b.id ? 1 : -1;
            });
            const sortedId = sortDetails[0].data.id.split('_')[2];
            if (dataFromId.length === 3 && sortDetails.length) {
                openModal(shift_1.ShiftModal, {
                    initialData: {
                        type: 'cycle',
                        shiftId: cycleDetail.lastSavedCycleShift?.data.id ?? undefined,
                        cycle: {
                            colId: parseInt(dataFromId[1]),
                            groupId: parseInt(dataFromId[0]),
                            eventId: parseInt(sortedId) + 1,
                        },
                    },
                });
            }
        }
        else {
            openModal(shift_1.ShiftModal, {
                initialData: {
                    type: 'live',
                    data: {
                        userId: data.userId,
                        period: {
                            start: (0, moment_1.default)(data.period.start),
                            end: (0, moment_1.default)(data.period.end),
                        },
                    },
                },
            });
        }
        util_1.multiSelectUtil.multiSelectClear();
    };
    // edit handlers
    const handleEditShift = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openEventModal(data, 'shift', eventProps);
        util_1.multiSelectUtil.multiSelectClear();
    };
    const handleEditUnav = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const availOrTimeOff = util_1.calendarUtil.isEventAvailabilityOrTimeOff(data);
        openEventModal(data, availOrTimeOff, eventProps);
        util_1.multiSelectUtil.multiSelectClear();
    };
    const handleEtitShiftTemplate = (_e) => {
        openModal(shift_1.ShiftModal, {
            initialData: {
                type: 'shiftTemplate',
                shiftTemplateId: data.id,
            },
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    // unassign handler
    const handleUnassign = (e) => {
        e.preventDefault();
        e.stopPropagation();
        updateLiveShift(data.id, { userId: null });
    };
    // copy handler
    const handleCopy = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setContextMenu(false);
        setTimeout(() => {
            util_1.notification.success({ code: 'eventCopied', message: undefined });
            setCalendarMultiSelect({
                action: 'copy',
                isSelectingTargets: true,
                sourceEvents: [Object.assign({}, data)],
                targets: [],
            });
        }, 100); // we use setTimeout here, so that this is called *after* the Schedule component's dragSelect.callback() is resolved
    };
    // applyShiftTemplate handler
    const handleApplyShiftTemplate = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setContextMenu(false);
        setTimeout(() => {
            util_1.notification.success({ code: 'eventCopied', message: undefined });
            setCalendarMultiSelect({
                action: 'applyShiftTemplate',
                isSelectingTargets: true,
                targets: [],
                isActive: true,
            });
        }, 100); // we use setTimeout here, so that this is called *after* the Schedule component's dragSelect.callback() is resolved
    };
    // delete handler
    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (type === 'shiftTemplate') {
            updateShiftTemplate(data.id, null, null);
        }
        else {
            setModal('confirm', {
                title: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_TITLE'),
                subtitle: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_DELETE_SUBTITLE_X', { x: 1 }),
                recordsList: [data],
                confirmLabel: (0, util_1.t)('DELETE'),
                onConfirm: () => {
                    if (type === 'shift' && !isCycleCalendar) {
                        deleteLiveShift(data.id, undefined, undefined, data?.transfer?.slaves?.length >= 1);
                    }
                    if (type === 'shift' && isCycleCalendar) {
                        deleteCycleDetail({
                            data,
                        });
                    }
                    if (type === 'availability') {
                        void (0, request_1.requestAvailabilityDeleteMulti)({
                            data: [{ id: data.id }],
                            workspace: workspace?.id,
                        }, auth).then((r) => {
                            if (!r?.error)
                                util_1.notification.success({ code: 'success', message: undefined });
                        });
                    }
                    if (type === 'timeOff') {
                        void (0, request_1.requestTimeOffDeleteMulti)({
                            data: [{ id: data.id }],
                            workspace: workspace?.id,
                        }, auth).then((r) => {
                            if (!r?.error)
                                util_1.notification.success({ code: 'success', message: undefined });
                        });
                    }
                    util_1.multiSelectUtil.multiSelectClear();
                },
                cancelLabel: (0, util_1.t)('CANCEL'),
                onCancel: () => { },
                overSidebar: true,
                buttonColor: 'red',
            });
        }
        util_1.multiSelectUtil.multiSelectClear();
    };
    // publish handler
    const handlePublish = (e) => {
        e.preventDefault();
        e.stopPropagation();
        void (0, apollo_client_fetch_1.ApolloClientFetch)(auth, 'ShiftsPublishMutation').mutate({
            mutation: (0, client_1.gql) `
        ${query_1.ANNOUNCE_SHIFTS}
      `,
            variables: {
                workspaceId: workspace.id,
                ids: [data.id],
            },
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    // offer handler
    const handleOffer = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setModal('offers', {
            selectedShiftIds: [data.id],
            action: 'create',
            createType: 'drop',
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    // swap handler
    const handleSwap = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setModal('offers', {
            selectedShiftIds: [data.id],
            action: 'create',
            createType: 'swap',
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    // autoplan handler
    const handleAutoPlan = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Only opens the planner panel — PlanningSetup takes it from here and submits the plan
        // itself once the manager has picked the settings. It used to createPlan() with defaults
        // right away, which raced the panel it had just opened and skipped the setup entirely.
        openPlanning();
    };
    // add unav handler
    const handleAddUnav = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal(unavailability_modal_1.UnavailabilityModal, {
            initialData: {
                userId: data.userId,
                period: {
                    start: (0, moment_1.default)(data.period.start).format('YYYY-MM-DD'),
                },
                contractId: calendarMultiSelect.sourceEvents?.[0]?.contractId ?? undefined,
            },
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    // save as shift template handler
    const handleSaveAsShiftTemplate = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal(shift_1.ShiftModal, {
            initialData: {
                type: 'shiftTemplate',
                data: {
                    period: data.period,
                    positionId: data.positionId,
                    localityId: data.localityId,
                    pauses: data.pausesFixed ? data.pauses : undefined,
                    pausesFixed: data.pausesFixed,
                    idealSkill: data.idealSkill,
                    note: data.note,
                    overTime: data.overTime,
                    standBy: data.standBy,
                    standByActivities: [],
                    customAttributes: data.customAttributes,
                    agenda: data.agenda,
                },
            },
        });
        util_1.multiSelectUtil.multiSelectClear();
    };
    const menuItems = [];
    // MENU ITEMS FOR MULTISELECTION
    if (calendarMultiSelect.sourceEvents.length >= 2) {
        const multiselectActions = util_1.multiSelectUtil.getMultiSelectAllowedActionTypes(isPluginEnabled) || [];
        multiselectActions.forEach((act, i) => {
            let name = act.type;
            let icon = null;
            if (act.type === 'updateShiftTemplate') {
                name = (0, util_1.t)('MULTI_SHIFT_TEMPLATE_UPDATE');
                icon = _ui_1.Icon.ICONS.edit;
            }
            if (act.type === 'applyShiftTemplate') {
                name = (0, util_1.t)('MULTI_SHIFT_TEMPLATE_APPLY');
                icon = _ui_1.Icon.ICONS.check;
            }
            if (act.type === 'delete') {
                name = (0, util_1.t)('DELETE');
                icon = _ui_1.Icon.ICONS.delete;
                if (menuItems.length !== 0)
                    menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_' + String(i) }));
            }
            if (act.type === 'switchTwoShifts') {
                name = (0, util_1.t)('MULTI_ACTION_SWAP_SHIFTS');
                icon = _ui_1.Icon.ICONS.switch;
            }
            if (act.type === 'copy') {
                name = (0, util_1.t)('MULTI_ACTION_COPY_CONFIRM');
                icon = _ui_1.Icon.ICONS.duplicate;
            }
            if (act.type === 'unassign') {
                name = (0, util_1.t)('EVT_TOOLTIP_CM_UNASSIGN');
                icon = _ui_1.Icon.ICONS.unoccupied;
            }
            if (act.type === 'viewOffers') {
                name = (0, util_1.t)('OFFERS');
                icon = _ui_1.Icon.ICONS.offer;
            }
            if (act.type === 'cancelOffers') {
                name = (0, util_1.t)('MULTI_ACTION_UNASSIGN');
                icon = _ui_1.Icon.ICONS.close1;
            }
            if (act.type === 'startDropOffers') {
                name = (0, util_1.t)('MULTI_ACTION_START_OFFERS');
                icon = _ui_1.Icon.ICONS.assign;
            }
            if (act.type === 'startSwapOffers') {
                name = (0, util_1.t)('MULTI_ACTION_START_SWAP');
                icon = _ui_1.Icon.ICONS.switch;
            }
            if (act.type === 'autoplan') {
                name = (0, util_1.t)('MULTI_ACTION_AUTOPLAN');
                icon = _ui_1.Icon.ICONS.items;
            }
            if (act.type === 'batchUpdateShifts') {
                name = (0, util_1.t)('MULTI_ACTION_BATCH_UPDATE');
                icon = _ui_1.Icon.ICONS.edit;
                menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_' + String(i) }));
            }
            if (act.type === 'updateSingleEvent') {
                name = (0, util_1.t)('MULTI_ACTION_UPDATE_SINGLE_' +
                    (calendarMultiSelect.sourceEvents[0].positionId ? 'SHIFT' : 'UNAV'));
                icon = _ui_1.Icon.ICONS.edit;
            }
            if (act.type === 'deselectShifts') {
                name = (0, util_1.t)('MULTI_ACTION_DESELECT_SHIFTS');
                icon = _ui_1.Icon.ICONS.close1;
            }
            if (act.type === 'deselectUnavs') {
                name = (0, util_1.t)('MULTI_ACTION_DESELECT_UNAVS');
                icon = _ui_1.Icon.ICONS.close1;
            }
            if (act.type === 'deselectTimeOffs') {
                name = (0, util_1.t)('MULTI_ACTION_DESELECT_TIMEOFFS');
                icon = _ui_1.Icon.ICONS.close1;
            }
            if (act.type === 'deselectAll') {
                name = (0, util_1.t)('MULTI_ACTION_CANCEL_SELECTION');
                icon = _ui_1.Icon.ICONS.close1;
            }
            const handler = () => {
                util_1.multiSelectUtil.multiSelectExecuteAction(act.type);
            };
            menuItems.push(react_1.default.createElement("div", { key: 'ms_' + String(i), onMouseDown: handler, onTouchStart: handler, className: act.type === 'delete' ? 'evt-tt-red-btn' : undefined },
                icon && (react_1.default.createElement(_ui_1.Icon, { ico: icon, size: 'small' })),
                name));
            if (act.type === 'switchTwoShifts') {
                menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_' + String(i) }));
            }
        });
    }
    // MENU ITEMS FOR SINGLE SELECTION
    if (calendarMultiSelect.sourceEvents.length === 1) {
        if (type === 'shift' && !data.hasOffer) {
            // unassign
            if (data.userId) {
                menuItems.push(react_1.default.createElement("div", { key: 'context_unass', onMouseDown: handleUnassign, onTouchStart: handleUnassign },
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.unoccupied, size: 'small' }),
                    (0, util_1.t)('EVT_TOOLTIP_CM_UNASSIGN')));
            }
            if (isPluginEnabled('offers') &&
                !isCycleCalendar &&
                (0, moment_1.default)(data?.period.start).isAfter((0, moment_1.default)().add(1, 'hour'))) {
                // offer
                menuItems.push(react_1.default.createElement("div", { key: 'context_offer', onMouseDown: handleOffer, onTouchStart: handleOffer },
                    react_1.default.createElement(_ui_1.Icon, { ico: 'assign', size: 'small' }),
                    (0, util_1.t)('MULTI_ACTION_START_OFFERS')));
                // swap
                if (data.userId &&
                    calendarMultiSelect.sourceEvents?.length === 2 &&
                    !calendarMultiSelect.sourceEvents.some((evt) => evt.categoryId || !evt.userId)) {
                    // swap
                    menuItems.push(react_1.default.createElement("div", { key: 'context_swap', onMouseDown: handleSwap, onTouchStart: handleSwap },
                        react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.switch, size: 'small' }),
                        (0, util_1.t)('MULTI_ACTION_START_SWAP')));
                }
            }
            // autoplan
            if (!data.userId) {
                menuItems.push(react_1.default.createElement("div", { key: 'context_autoplan', onMouseDown: handleAutoPlan, onTouchStart: handleAutoPlan },
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.items, size: 'small' }),
                    (0, util_1.t)('MULTI_ACTION_AUTOPLAN')));
            }
            // add unav
            if (data.userId && !isCycleCalendar) {
                menuItems.push(react_1.default.createElement("div", { key: 'context_add_unav', onMouseDown: handleAddUnav, onTouchStart: handleAddUnav },
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.absence, size: 'small' }),
                    (0, util_1.t)('COL_TOOLTIP_CM_ADD_ABSENCE')));
            }
        }
        // divider
        if (menuItems.length !== 0)
            menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_before_add_shift' }));
        // add shift
        if (type !== 'shiftTemplate') {
            menuItems.push(react_1.default.createElement("div", { key: 'context_add_shift', onMouseDown: handleAddShift, onTouchStart: handleAddShift },
                react_1.default.createElement(_ui_1.Icon, { ico: 'plus', size: 'small' }),
                (0, util_1.t)('EVT_TOOLTIP_CM_ADD_SHIFT')));
        }
        // edit
        menuItems.push(react_1.default.createElement("div", { key: 'context_edit', onMouseDown: type === 'shift'
                ? handleEditShift
                : type === 'shiftTemplate'
                    ? handleEtitShiftTemplate
                    : handleEditUnav, onTouchStart: type === 'shift'
                ? handleEditShift
                : type === 'shiftTemplate'
                    ? handleEtitShiftTemplate
                    : handleEditUnav },
            react_1.default.createElement(_ui_1.Icon, { ico: 'edit', size: 'small' }),
            (0, util_1.t)('EVT_TOOLTIP_CM_EDIT')));
        // copy
        if (!hasMaster && !isCycleCalendar && type !== 'shiftTemplate') {
            menuItems.push(react_1.default.createElement("div", { key: 'context_copy', onMouseDown: handleCopy, onTouchStart: handleCopy },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.duplicate, size: 'small' }),
                (0, util_1.t)('COPY')));
        }
        // apply shift template
        if (type === 'shiftTemplate') {
            menuItems.push(react_1.default.createElement("div", { key: 'context_apply_template', onMouseDown: handleApplyShiftTemplate, onTouchStart: handleApplyShiftTemplate },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.duplicate, size: 'small' }),
                (0, util_1.t)('COPY')));
        }
        // publish shift
        if (type === 'shift' && !data.published && !isCycleCalendar) {
            menuItems.push(react_1.default.createElement("div", { key: 'context_pub', onMouseDown: handlePublish, onTouchStart: handlePublish },
                react_1.default.createElement(_ui_1.Icon, { ico: 'publish', size: 'small' }),
                (0, util_1.t)('EVT_TOOLTIP_CM_PUBLISH')));
        }
        // save as template
        if (type === 'shift' && !isCycleCalendar) {
            if (menuItems.length !== 0)
                menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_before_save_template' })); // divider
            menuItems.push(react_1.default.createElement("div", { key: 'context_save_template', onMouseDown: handleSaveAsShiftTemplate, onTouchStart: handleSaveAsShiftTemplate },
                react_1.default.createElement(_ui_1.Icon, { ico: 'save', size: 'small' }),
                (0, util_1.t)('EVT_TOOLTIP_SAVE_AS_SHIFT_TPL')));
        }
        // delete
        if (!hasMaster && !data.requestPendingAction) {
            if (menuItems.length !== 0)
                menuItems.push(react_1.default.createElement("div", { className: 'is-divider', key: 'divider_before_del' })); // divider
            menuItems.push(react_1.default.createElement("div", { key: 'context_del', onMouseDown: handleDelete, onTouchStart: handleDelete, className: 'evt-tt-red-btn', "data-testid": 'delete-event-button' },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.delete, size: 'small' }),
                (0, util_1.t)('DELETE')));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        topSectionRows,
        contextMenu && !isLockedDay && react_1.default.createElement("div", { className: 'evt-tt-cm' }, menuItems)));
};
exports.default = TooltipContent;
